import React from 'react'
import { ErrorBoundary } from '@CommonComponents'
import { Connection } from '@LTIDashboard/modules/GeneralDashboard/Connection'
import { ResourcesController } from '@LTIDashboard/modules/GeneralDashboard/Resources'
import { AssessmentsController } from '@LTIDashboard/modules/GeneralDashboard/Assessments'
import { useConnectionValue } from '@LTIDashboard/state'

export function GeneralDashboard() {
  const { status } = useConnectionValue()
  return (
    <div>
      <ErrorBoundary resetKeys={[history.state]}>
        <ErrorBoundary>
          <Connection />
        </ErrorBoundary>
        {status === 'loaded' ? (
          <React.Fragment>
            <ErrorBoundary>
              <ResourcesController />
            </ErrorBoundary>
            <ErrorBoundary>
              <AssessmentsController />
            </ErrorBoundary>
          </React.Fragment>
        ) : (
          ''
        )}
      </ErrorBoundary>
    </div>
  )
}
